<template>
	<div
		class="flex flex-col md:flex-row items-center gap-24 justify-between"
		:class="classes"
		:data-test-position="imagePosition"
		data-testid="content-block"
	>
		<slot name="image" />
		<div class="flex flex-col gap-4 lg:gap-6">
			<slot name="content" />
		</div>
	</div>
</template>

<script lang="ts" setup>
const props = withDefaults(
	defineProps<{
		imagePosition?: 'left' | 'right';
	}>(),
	{
		imagePosition: 'left',
	}
);

const classes = computed(() => {
	const classes = [];

	if (props.imagePosition === 'right') {
		classes.push('md:flex-row-reverse');
	}
	else {
		classes.push('md:flex-row');
	}

	return classes;
});
</script>
